export const ACCESS_TYPE = {
	ADMIN: 'ADMIN',
	FULL: 'FULL',
	BASIC: 'BASIC',
};
